/*
 * @Description: 外调车线路 store
 * @Author: lijinpeng
 * @Date: 2022-10-11 16:14:23
 * @LastEditTime: 2024-04-22 10:30:04
 * @LastEditors: lijinpeng
 */
// 引入api请求方法
import { getGroups } from '@/api/common';
import { getProjectListByBid } from '@/api/project';
import { postRoutePageList, getRouteListByBid, routeExportUrl } from '@/api/routeInfo';
import { payTypeList, priceTypeList } from '@/utils/dictionary';

const storeModuleName = 'routeTransferModule';
const state = {
  // 筛选项-
  parameters: [
    {
      style: 'select',
      param: 'businessId',
      isFixed: true,
      value: '',
      valueType: 'string',
      state: 'companyList',
      label: '企业',
      placeholder: '请选择',
      noMatchText: '无匹配企业',
      clearable: false,
      filterable: false,
      path: `${storeModuleName}/getCompanyList`,
    },
    {
      style: 'autocomplete',
      param: 'projectName',
      value: '',
      state: 'projectList',
      isFixed: true,
      valueType: 'string',
      label: '项目名称',
      placeholder: '请输入',
      noMatchText: '无匹配请输入',
      clearable: true,
      filterable: false,
      path: `${storeModuleName}/getProjectList`,
    },
    {
      style: 'autocomplete',
      param: 'routeInfoName',
      value: '',
      valueType: 'string',
      label: '线路名称',
      placeholder: '请输入',
      noMatchText: '无匹配请输入',
      clearable: true,
      filterable: false,
      path: `${storeModuleName}/getRouteList`,
    },
    {
      style: 'select',
      param: 'priceType',
      value: '',
      valueType: 'string',
      state: 'priceTypeList',
      label: '定价方式',
      placeholder: '请选择',
      clearable: true,
      filterable: false,
    },
    {
      style: 'select',
      param: 'payType',
      value: '',
      valueType: 'string',
      state: 'payTypeList',
      label: '支付方式',
      placeholder: '请选择',
      clearable: true,
      filterable: false,
    },
    {
      style: 'date-picker',
      param: 'createTime',
      value: [],
      valueType: 'date',
      label: '创建时间',
      placeholder: '请选择',
      type: 'daterange',
      format: 'MM-dd',
      valueFormat: 'yyyy-MM-dd',
      clearable: true,
      params: ['createStartTime', 'createEndTime'],
    },
    {
      style: 'input',
      param: 'creatorName',
      value: '',
      valueType: 'string',
      label: '创建人',
      placeholder: '请输入',
      clearable: true,
    },
  ],
  // tabs筛选项
  isSpecialTabs: false,
  isSpecialButton: [
    {
      title: '',
      name: 'waybillStatus',
      value: '',
      selectList: [],
    },
  ],
  isExport: {
    isShow: true,
    method: 'post',
    url: routeExportUrl,
  }, // 导出
  // 页码
  postParams: {
    page: 1,
    size: 20,
  },
  // 列表data数据
  listData: {
    list: [],
    tableHeadList: [
      {
        label: '企业名称',
        prop: 'companyName',
        width: 170,
        fixed: 'left',
        checked: 1,
        sortable: true,
        slotName: 'sub-domain-companyName',
      },
      {
        label: '线路名称',
        prop: 'routeName',
        width: 140,
        checked: 1,
        sortable: true,
        slotName: 'sub-domain-routeName',
      },
      {
        label: '装卸货地',
        prop: 'address',
        width: 240,
        checked: 1,
        sortable: true,
        slotName: 'sub-domain-address',
      },
      {
        label: '线路信息',
        prop: 'routeInfo',
        width: 140,
        checked: 1,
        sortable: true,
        slotName: 'sub-domain-routeInfo',
      },
      {
        label: '承运网货',
        prop: 'channelInfoName',
        width: 140,
        checked: 1,
        sortable: true,
        slotName: 'sub-domain-channelInfoName',
      },
      {
        label: '创建时间',
        prop: 'createTime',
        width: 140,
        checked: 1,
        sortable: true,
        slotName: 'sub-domain-createTime',
      },
      {
        label: '操作',
        width: 80,
        fixed: 'right',
        checked: 1,
        sortable: true,
        slotName: 'sub-domain-operation',
      },
    ],
  },
  companyList: [], // 企业列表
  companyInfo: '', // 当前选中的企业信息
  projectList: [], // 项目列表
  routeList: [], // 线路列表
  projectInfo: '', // 当前选中的项目信息
  priceTypeList, // 定价方式
  payTypeList, // 运费支付方式
};

// getters
const getters = {};

// actions
const actions = {
  // 获取列表数据
  getList: async context => {
    const params = {};
    context.state.parameters.forEach(item => {
      if (item.style !== 'date-picker' && item.value) {
        params[item.param] = item.value;
      }
      if (item.style === 'date-picker' && item.value.length > 0) {
        params[item.params[0]] = `${item.value[0]} 00:00:00`;
        params[item.params[1]] = `${item.value[1]} 23:59:59`;
      }
    });
    var routerListHabits = {};
    const obj = Object.assign({}, context.state.postParams);
    if (obj.businessId || params.businessId) {
      routerListHabits.businessId = obj.businessId ? obj.businessId : params.businessId;
    }
    if (obj.projectId) {
      routerListHabits.projectId = obj.projectId;
    }
    if (obj.routeInfoId) {
      routerListHabits.routeInfoId = obj.routeInfoId;
    }
    localStorage.setItem('routerListHabits', JSON.stringify(routerListHabits));

    const { data } = await postRoutePageList(Object.assign({}, params, context.state.postParams));
    context.commit('updateState', {
      key: 'listData',
      value: Object.assign({}, context.state.listData, data),
    });
    return data.list;
  },
  // 获取企业列表
  getCompanyList: async (context, payload) => {
    const { code, data } = await getGroups({
      corIdOrName: payload,
    });
    if (code === 200) {
      // 只展示实名认证的企业列表
      context.commit('updateState', {
        key: 'payPwdExist',
        value: data.payPwdExist,
      });
      context.commit('updateState', {
        key: 'payPwdStatus',
        value: data.payPwdStatus,
      });
      const list = data.corporations.filter(item => item.realNameAudit === 1);
      if (list.length) {
        list.forEach(item => {
          item.label = item.principalPartName;
          item.value = item.businessId;
        });
      }
      context.commit('updateState', {
        key: 'companyList',
        value: list,
      });
    }
  },

  // 获取项目列表
  getProjectList: async (context, keyword) => {
    return new Promise(async (resolve, reject) => {
      const { code, data } = await getProjectListByBid({
        businessId: context.state.parameters[0].value,
        keyword,
      });
      if (code === 200) {
        data.list.forEach(item => {
          item.value = item.name;
        });
        context.commit('updateState', {
          key: 'projectList',
          value: data.list,
        });
        resolve(data.list);
      } else {
        reject();
      }
    });
  },
  // 获取线路列表
  getRouteList: async (context, keyword) => {
    return new Promise(async (resolve, reject) => {
      const { code, data } = await getRouteListByBid({
        businessId: context.state.parameters[0].value,
        projectId: context.state.postParams.projectId,
        lineType: 'transfer',
        keyword,
      });
      if (code === 200) {
        data.list.forEach(item => {
          item.value = item.orderName;
        });
        context.commit('updateState', {
          key: 'routeList',
          value: data.list,
        });
        resolve(data.list);
      } else {
        reject();
      }
    });
  },
};
// mutations
const mutations = {
  // 重置所有状态
  initFilter(state) {
    state.postParams = {
      page: 1,
      size: 20,
      lineType: 'transfer',
    };
    state.parameters.forEach(item => {
      if (item.isFixed) {
        return;
      }
      if (item.style !== 'date-picker' && item.value) {
        item.value = '';
      }
      if (item.style === 'date-picker') {
        item.value = [];
      }
    });
  },
  // 更新state数据
  updateState(state, { key, value }) {
    state[key] = value;
  },
  // 更新列表参数数据
  updatePostParams(state, payload) {
    state.postParams = Object.assign({}, state.postParams, payload);
  },
  upmyselfLine(state, payload) {
    state.postParams.myselfLine = payload;
  },
  // 根据index更新value
  updateValueFromIndex(state, payload) {
    state.parameters[payload.index].value = payload.value;
    switch (state.parameters[payload.index].param) {
      case 'businessId':
        if (payload.from !== 1) {
          localStorage.removeItem('routerListHabits');
          localStorage.setItem(
            'routerListHabits',
            JSON.stringify({
              businessId: payload.value,
            }),
          );
        }
        state.companyInfo = state.companyList.find(item => item.businessId === payload.value);
        if (state.parameters[1].value) {
          state.parameters[1].value = '';
          state.postParams.projectId = '';
        }
        if (state.parameters[2].value) {
          state.parameters[2].value = '';
          state.postParams.routeInfoId = '';
        }
        break;
      case 'projectName':
        state.postParams.projectId = payload.id;
        state.projectInfo = state.projectList.find(item => item.id === payload.id);
        if (state.parameters[2].value) {
          state.parameters[2].value = '';
          state.postParams.routeInfoId = '';
        }
        break;
      case 'routeInfoName':
        state.postParams.routeInfoId = payload.id;
        break;
      default:
        break;
    }
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
